import {
  useTenantAddons,
  TenantAddonConstants,
} from '../../../../components/tenant-addons';
import { useRoleThemes } from '../../../../authentication/use-role-themes';

// The service-provider (Udfører) area also hosts Sociallægeligt Samarbejde (SLS).
// SLS-only tenants never bought the SocialUdfører add-on; they reach the same area
// through their own MedicalCollaboration add-on combined with a medical-collaborator role.
export function useMedicalCollaborationAreaAccess() {
  const { isTenantAddonEnabled } = useTenantAddons();
  const { isMedicalCollaborator } = useRoleThemes();

  return (
    isMedicalCollaborator &&
    isTenantAddonEnabled([TenantAddonConstants.MedicalCollaboration])
  );
}

// Udfører (service-provider) users reach the area through the SocialUdfører add-on.
export function useUdfoererAreaAccess() {
  const { isTenantAddonEnabled } = useTenantAddons();
  const { isServiceProvider } = useRoleThemes();

  return (
    isServiceProvider &&
    isTenantAddonEnabled([TenantAddonConstants.SocialUdfoerer])
  );
}

// Whether the user may enter the service-provider area at all. Each user kind needs
// its own add-on: udfører users the SocialUdfører add-on, medical collaborators the
// MedicalCollaboration add-on. A medical collaborator must not slip in on a tenant
// that only bought SocialUdfører (and vice versa).
export function useServiceProviderAreaAccess() {
  const hasUdfoererAccess = useUdfoererAreaAccess();
  const hasMedicalCollaborationAccess = useMedicalCollaborationAreaAccess();

  return hasUdfoererAccess || hasMedicalCollaborationAccess;
}
